import React from "react";
import { ReactComponent as TickIcon } from "assets/img/svg/TickIcon.svg"; // same icon used in system
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import ChequeDetails from "./ChequeDetails";
import {
  getFormattedAmount,
  getFormattedDate,
} from "../../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

const tickStyle = {
  background: "#05945B",
  borderRadius: "50%",
  height: "30px",
  width: "30px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const fontColor = {
  color: "#07794C",
};

const SuccessMessageAlert = ({
  details = {}, // { totalReceipts, totalAmount, depositSlipId }
  onClose = () => {}, // Go to dashboard / close modal
  onView = () => {}, // View deposit slip
  row = {},
  isChequeBounced = false,
}) => {
  const { psid = "--", amount = 0, depositSlipId = "--" } = details;

  console.log("details in success message", details);
  return (
    <div style={{ minWidth: "400px" }}>
      {/* Header */}
      <div className="d-flex align-items-center gap-3 mb-4">
        <div style={tickStyle}>
          <TickIcon />
        </div>
        {/* <div className="extra-large-bold color-black">
          Cash deposit send for approval
        </div> */}
      </div>

      <ChequeDetails
        psid={row?.psid}
        chequeNumber={row?.referenceNumber}
        chequeAmount={row?.amountCollected}
        chequeDate={getFormattedDate(row?.paymodeDate)}
      />

      <div className="d-flex gap-3">
        {isChequeBounced && (
          <div className="regular-text semi-bold mt-3" style={fontColor}>
            {`Bounce charges ${getFormattedAmount(
              details?.amount
            )}/- has been applied`}
          </div>
        )}
      </div>
    </div>
  );
};

export default SuccessMessageAlert;
